import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/(auth)/account/spaces/page.tsx");
